import { useMutation } from "react-query";
import { getLeasedEquipmentByRecordNumber } from "../../../../actions/CarrierAgreementMgmt/LeasedEquipment";

export const useGetLeasedEquipmentForEdit = () => {
  return useMutation(getLeasedEquipmentByRecordNumber);
};
